/**
 * Deterministic funnel event_id for browser↔s2s dedup (P8-F7b, ADR-0003).
 *
 * BYTE-for-byte mirror of the server util
 * (backend/src/attribution/utils/funnel-event-id.util.ts):
 *   input  = `${sessionId}:${eventType}`   (ONE colon separator)
 *   eventType = enum name, UPPER (CHECKOUT_SUCCESS, EMAIL_SUBMIT, ...)
 *   output = SHA-256(UTF-8 input) → hex → lowercase
 *
 * Uses Web Crypto SubtleCrypto. Any divergence from the server (separator, case,
 * encoding) breaks network dedup → double-count. The shared golden-vector test
 * (both codebases) guards this.
 */
export async function computeFunnelEventId(
  sessionId: string,
  eventType: string,
): Promise<string> {
  const input = `${sessionId}:${eventType}`;
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
